/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdminBulkIndexActivityToElasticRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {AdminBulkIndexActivityToElasticResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const adminBulkIndexActivityToElastic = (request:AdminBulkIndexActivityToElasticRequest, options?: CashRequestOptions) => post<AdminBulkIndexActivityToElasticRequest, AdminBulkIndexActivityToElasticResponse>("/2.0/cash/admin-bulk-index-activity-to-elastic", request, {...options, rejectOnError: true })